export function getPinterestRedirect(reconnect: boolean, v3 = false): string {
  // NOTE: don't need to actually do a HTTP GET for Pinterest, as it
  // just redirects, so just changing window location to this URL
  let url = v3 ? "/pi/request_token" : "/pi/v5/request_token";

  if (reconnect) {
    url = url + "?reconnect=true";
  }
  return url;
}
